module.exports = __webpack_public_path__ + "img/logo.d38d74f4.svg";